import './CoursesReview.scss';
import { Slider } from '@components';
import icons from '@assets/icons/redesign';
import LinkWithTracking from '../../LinkWithTracking/LinkWithTracking';

const { Star } = icons;

const reviews = [
  {
    title: 'Zwangerschapscursus',
    text: 'Geweldige cursus. En helemaal gratis! Het werd door mijn zorgverzekering vergoed.',
    score: '9,5'
  },
  {
    title: 'Bevallingscursus',
    text: 'Informatieve cursus voor de bevalling. Ik vond het prettig om naar te kijken.',
    score: '8,0'
  },
  {
    title: 'Borstvoedingscursus',
    text: 'Fijn overzicht.',
    score: '8,3'
  },
  {
    title: 'Seksualiteit tijdens en na de zwangerschap',
    text: 'Doorbreekt taboes en dat is prettig.',
    score: '8,3'
  }
];

export default function CoursesReview({
  buttonLink,
  trackingCategory,
  trackingAction
}) {
  return (
    <section className="coursesReview">
      <div className="coursesReview-content">
        <div className="coursesReview-header">
          <div className="coursesReview-stars">
            {Array(5)
              .fill(null)
              .map((_, idx) => (
                <Star className="coursesReview-stars-icon" key={idx} />
              ))}
          </div>
          <h2 className="coursesReview-title">Wat anderen zeggen</h2>
        </div>

        <div className="coursesReview-list">
          <Slider
            loop={true}
            visibleSlides={3}
            slides={reviews.map(({ title, text, score }) => (
              <div className="coursesReview-slide" key={title}>
                <div className="coursesReview-course">
                  <h3 className="coursesReview-course-title">{title}</h3>
                  <p className="coursesReview-course-text">“{text}”</p>

                  <div className="coursesReview-course-footer">
                    <p className="coursesReview-course-score">
                      <i>
                        Cijfer:{' '}
                        <span className="coursesReview-course-score-value">
                          {score}
                        </span>
                      </i>
                    </p>

                    <div className="coursesReview-course-stars">
                      {Array(5)
                        .fill(null)
                        .map((_, i) => (
                          <Star
                            key={i}
                            className="coursesReview-course-stars-icon"
                          />
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          />
        </div>

        {buttonLink && (
          <LinkWithTracking
            href={buttonLink}
            className="coursesReview-button"
            category={trackingCategory}
            action={trackingAction}
          >
            Start jouw cursus nu
          </LinkWithTracking>
        )}
      </div>
    </section>
  );
}
